import { PARTNERSCORE_CUBE_NAME } from '@/api/hcp';
import { buildYearQuarterTreeOptions, DateItem } from '@/api/hcp/partnerscore/utils/yearQuarterTreeUtils';
import { FilterConfigDynamic } from '@/types/filter';
import { SelectItem } from '@/types/ui';
import { toNumberOrNull } from '@/utils/cube';

const YEAR_DIM = `${PARTNERSCORE_CUBE_NAME}.year`;
const QUARTER_DIM = `${PARTNERSCORE_CUBE_NAME}.quarter`;

const partnerScoreYearQuarterFilter: FilterConfigDynamic = {
  label: 'main.hcpOverview.partnerScore.filter.yearQuarter',
  placeholder: 'main.hcpOverview.partnerScore.filter.yearQuarter',
  type: 'oldtreeselect',
  defaultValue: [],
  clearable: false,
  sourceCube: PARTNERSCORE_CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [YEAR_DIM, QUARTER_DIM],
    limit: 5000,
  }),
  mapResult: result => {
    const year = toNumberOrNull(result[YEAR_DIM]);
    const quarter = toNumberOrNull(result[QUARTER_DIM]);
    if (!year || !quarter) return null;
    // Store as DateItem-compatible object; processOptions will transform into tree
    return { value: JSON.stringify({ year, quarter }), label: '' } as SelectItem;
  },
  processOptions: (options: SelectItem[]): SelectItem[] => {
    const dateItems: DateItem[] = options
      .map(opt => {
        try {
          return JSON.parse(opt.value) as DateItem;
        } catch {
          return null;
        }
      })
      .filter((item): item is DateItem => item !== null);

    return buildYearQuarterTreeOptions(dateItems);
  },
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    // Year/quarter filtering is handled by usePartnerScoreFilter utility functions,
    // not by a direct cube filter. Return undefined so it doesn't interfere.
    return undefined;
  },
};

export default partnerScoreYearQuarterFilter;
